import { ref, toRefs } from 'vue';
import { defineStore } from 'pinia';
import useKIEnginesStoreActions from './actions';
import useCommonGetters from '../common-getters';
import { IKIEnginesState, KIEngine } from './models';

export const useKIEnginesStore = defineStore('ki-engine', () => {
  const state = ref(<IKIEnginesState>{
    kiEngines: [],
    kiEngineOverview: {} as KIEngine,
    kiEngineProperties: {} as KIEngine,
    isSearchTriggered: false,
    chatsSearchBy: '',
    documents: [],
    facets: [],
    totalIndexes: '',
    activeDocument: '',
    deleteResult: [],
  });

  return {
    ...toRefs(state.value),
    ...useCommonGetters<IKIEnginesState>(state),
    ...useKIEnginesStoreActions(state),
  };
});
